import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'i18n';
import { mediaQueries } from 'styles/utils/mediaQueries';

function DepartureComponent({ departureAirport, date, duration }) {
  return (
    <Root>
      <Content>
        <Icon icon='plane-departure' />
        {departureAirport}
      </Content>
      <Content>
        <Icon icon='calendar-alt' />
        {date}
      </Content>
      <Content>
        <Icon icon={'clock'} />
        <FormattedMessage
          id={'hotDealsPage.duration.label'}
          description={`{duration}D`}
          defaultMessage={`{duration}D`}
          values={{ duration }}
        />
      </Content>
    </Root>
  );
}

export default DepartureComponent;

const Root = styled.div`
  display: flex;
  margin-top: 12px;
  margin-right: 12px;
  background: ${({ theme }) => `${theme.colors.primary.light}`};
  border-radius: 4px;
  border: ${({ theme }) => `solid 1px ${theme.colors.primary.default}`};
`;

const Content = styled.div`
  padding: 8px;
  font-size: 1.2em;
  border-right: ${({ theme }) => `solid 1px ${theme.colors.primary.default}`};
  color: ${({ theme }) => `${theme.colors.text.light}`};
  font-weight: 500;
  text-align: center;
  white-space: nowrap;

  &:last-child {
    border: none;

    ${mediaQueries.fromAndBelow.desktop`
			margin: 0 auto;
  `}
  }
`;

const Icon = styled(FontAwesomeIcon)`
  font-size: 1em;
  margin-right: 8px;
`;
